import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { useGoogleAds } from '../../../contexts/providers/GoogleAdsProvider/GoogleAdsContext'
import {
  GoogleAdSlot,
  GoogleGeneralSize,
} from '../../../sharedComponents/types'
import { getParameterByName } from '../../../utils'
import { MobileAd, PlacementContainer } from './TopBannerMobile.styles'
export const AD_WIDTH = 390
export const AD_HEIGHT = 220

interface TopBannerMobileProps {
  isLive?: boolean
  isVod?: boolean
}

const TEST_AD_SIZE = 'topBannerTestSize'

export const TopBannerMobile = ({ isLive, isVod }: TopBannerMobileProps) => {
  const router = useRouter()
  const { pathPlatform } = useGoogleAds()
  const [slot, setSlot] = useState<GoogleAdSlot | null>(null)

  const [size] = useState<GoogleGeneralSize>(() => {
    const useTestAdSize =
      getParameterByName(TEST_AD_SIZE) === 'true' ||
      !!sessionStorage.getItem(TEST_AD_SIZE)
    useTestAdSize && sessionStorage.setItem(TEST_AD_SIZE, 'true')

    const size: GoogleGeneralSize = [[AD_WIDTH, AD_HEIGHT]]
    if (useTestAdSize) {
      size.push([360, 204])
    }
    return size
  })

  useEffect(() => {
    if (pathPlatform) {
      setSlot({
        id: 'top-mobile-banner',
        path: `/36476105/${pathPlatform}/Top_mobile_new`,
        size,
      })
    }

    return () => setSlot(null)
  }, [pathPlatform, size])

  if (!slot) {
    return null
  }

  return (
    <PlacementContainer dark={isLive || isVod}>
      {/* key forces a remount on route change so the slot is defined
          again after GoogleAdsProvider destroys it on routeChangeStart */}
      <MobileAd key={router.asPath} slot={slot} />
    </PlacementContainer>
  )
}

export default TopBannerMobile
